import { render, staticRenderFns } from "./TaskContents.vue?vue&type=template&id=079bceba&scoped=true&"
import script from "./TaskContents.vue?vue&type=script&lang=ts&"
export * from "./TaskContents.vue?vue&type=script&lang=ts&"
import style0 from "./TaskContents.vue?vue&type=style&index=0&id=079bceba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079bceba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
